import React, { useEffect, useState } from "react";
import Link from "next/link";
import { StaticI18nLink } from "../Link";

import { useMenuMobile } from "../../hooks/useMenuMobile";

import { GrClose } from "react-icons/gr";
import styles from "./mobile-menu.module.scss";
import { utilityLinks } from "../../data/contact-info";

const MobileMenu = () => {
  const menuMobile = useMenuMobile();
  const [topDistanceMenu, setTopDistanceMenu] = useState(0);

  useEffect(() => {
    const actualScroll = window.pageYOffset;
    const header = document.querySelector("#header").offsetHeight;

    setTopDistanceMenu(header - actualScroll);
  }, []);

  return (
    !!topDistanceMenu && (
      <>
        <div
          id=""
          onClick={menuMobile.handleToggleMenu}
          className={styles.overlay}
          style={{
            top: topDistanceMenu,
          }}
        >
          a
        </div>
        <div
          className={styles.wrapper_menu_mobile}
          style={{
            top: topDistanceMenu,
          }}
        >
          <nav className={styles.navigation}>
            <ul>
              <li
                className={styles.closeBtn}
                onClick={menuMobile.handleToggleMenu}
              >
                <GrClose />
              </li>
              <li onClick={menuMobile.handleToggleMenu}>
                <StaticI18nLink href="/">
                  <a target="_blank" title="Sobre a Verzel link">
                    Sobre a Verzel
                  </a>
                </StaticI18nLink>
              </li>
              <li onClick={menuMobile.handleToggleMenu}>
                <StaticI18nLink href="#contact-us">
                  <a title="Contato link">
                    Contato
                  </a>
                </StaticI18nLink>
              </li>
              <li onClick={menuMobile.handleToggleMenu}>
                <StaticI18nLink href="#devaria">
                  <a title="Devaria link">
                    Devaria
                  </a>
                </StaticI18nLink>
              </li>
              <li onClick={menuMobile.handleToggleMenu}>
                <Link href={utilityLinks.workWithUs}>
                  <a target="_blank" title="Trabalhe conosco link">
                    Trabalhe conosco
                  </a>
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </>
    )
  );
};

export default MobileMenu;
